// src/components/Footer.js
import React from 'react';
import { Typography, Divider } from '@mui/material';

const Footer = () => {
  return (
    <>
      <Divider sx={{ mb: 3 }} />
      <Typography variant="body2" color="text.secondary" align='center'>
        &copy; Nocstela Inc. or Tendenec
      </Typography>
    </>
  );
};
export default Footer;